if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          select: this.querySelector('.localization-select'),
        };
        this.elements.select.addEventListener('change', this.onItemClick.bind(this));
      }

      connectedCallback() {
        this.resizeSelect();

        // console.log(this.elements.select);
      }

      resizeSelect() {
        // Create a temporary span element to measure the text width
        const tempSpan = document.createElement('span');
        tempSpan.textContent = this.elements.select.value;
        tempSpan.style.visibility = 'hidden';
        tempSpan.style.position = 'absolute';
        tempSpan.style.left = '-10000px';
        document.body.appendChild(tempSpan);

        // Set the select element width to match the width of the selected option
        this.elements.select.style.width = tempSpan.offsetWidth + 6 + 'px';
        document.body.removeChild(tempSpan);
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');

        this.resizeSelect();
        this.elements.input.value = this.elements.select[this.elements.select.selectedIndex].getAttribute('data-value');

        if (form) form.submit();
      }
    }
  );
}
